import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuthStore } from '@/store/auth.store';
import { useAuditorAuthStore } from '@/store/auditor-auth.store';

export function ProtectedRoute() {
  const { isAuthenticated, isInitialized } = useAuthStore();
  const { isAuditorAuthenticated } = useAuditorAuthStore();
  const location = useLocation();

  if (!isInitialized) {
    // Still attempting token refresh on page load — render nothing (handled in main.tsx)
    return null;
  }

  if (!isAuthenticated) {
    // AC-SJ-10: if an auditor session is active, redirect to auditor dashboard
    // rather than the tenant-staff login to prevent cross-session confusion.
    if (isAuditorAuthenticated) {
      toast.info('You are signed in as an external auditor; access is limited to the audit scope.');
      return <Navigate to="/auditor/dashboard" replace />;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
